<template>
	<v-app>
		<template v-if="$route.path != '/calendar' && $route.path != '/calendar/' && !($route.meta && $route.meta.portal)">

			<v-navigation-drawer
				fixed
				app
				floating
				:width="$vuetify.breakpoint.smAndDown ? '280' : '250'"
				:mini-variant="isMini"
				:mini-variant-width="56"
				class="background-1"
				v-if="$store.getters.isAuthenticated"
				v-model="drawer"
				:permanent="$vuetify.breakpoint.mdAndUp"
				:swipeable="$vuetify.breakpoint.smAndDown"
				:style="moduleGroupBorderVars">
				<v-toolbar v-if="!isMini" flat class="transparent">
					<v-list text rounded dense class="pa-0" style="width: 100%">
						<v-list-item ripple :to="{path: '/profile'}" active-class="primary--text" class="pl-0">
							<v-list-item-avatar v-if="!$store.getters.getProfile.avatar" class="mr-3">
								<v-icon x-large>account_circle</v-icon>
							</v-list-item-avatar>
								<v-avatar v-else
									class="mr-2 custom-avatar"
									:size="40"
									:style="{'background-image': 'url(' + $store.getters.getProfile.avatar + ')'}">
								</v-avatar>
							<v-list-item-content>
								<v-list-item-title>{{ $store.getters.getProfile.name}}</v-list-item-title>
								<v-list-item-subtitle>{{ $store.getters.getProfile.email}}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-toolbar>
				<v-list nav rounded :class="{'pt-0': !isMini, 'pt-2': isMini}" dense v-if="$store.getters.getPermissions">

					<!-- Profilo in mini mode -->
					<v-tooltip v-if="isMini" right>
						<template v-slot:activator="{ on }">
							<v-list-item v-on="on" ripple :to="{path: '/profile'}" active-class="primary--text" class="mini-menu-item mb-2">
								<v-icon v-if="!$store.getters.getProfile.avatar" :size="28">account_circle</v-icon>
								<v-avatar v-else
									class="custom-avatar"
									:size="28"
									:style="{'background-image': 'url(' + $store.getters.getProfile.avatar + ')'}">
								</v-avatar>
							</v-list-item>
						</template>
						<span>{{ $store.getters.getProfile.name }}</span>
					</v-tooltip>
					<v-divider v-if="isMini" class="mb-2"></v-divider>

					<template v-for="(item, i) in groupedMenuItems">
						<v-list-group v-if="(item.children || item._settingsItems || item.permissions) && !isMini" :value="item.active || $route.path.startsWith('/' + (item.router || 'hr'))" :key="i" id="module" active-class="primary--text">
							<template v-slot:activator>
								<v-list-item-action>
									<v-icon class="fs20i">{{ item.icon }}</v-icon>
								</v-list-item-action>
								<v-list-item-content class="item-menu">
									<v-list-item-title>
										{{ item.trans }}
									</v-list-item-title>
								</v-list-item-content>
							</template>
							<template v-for="(child, c) in (item.children || item._settingsItems || item.permissions)">
								<v-list-item
									v-if="child.menu"
									:key="c"
									:to="{path: '/' + (child.router || child._settingsKey || c)}"
									id="module"
									active-class="primary--text"
									ripple
									>
									<v-list-item-action v-if="child.icon">
										<v-icon class="fs20i">{{ child.icon }}</v-icon>
									</v-list-item-action>
									<v-list-item-content class="item-menu">
										<v-list-item-title>
											{{ child.trans }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</template>
						</v-list-group>

						<v-tooltip v-else-if="(item.children || item.permissions) && isMini" right :key="'mini-group-'+i">
							<template v-slot:activator="{ on }">
								<v-list-item v-on="on" id="module" class="mini-menu-item">
									<v-icon class="fs20i">{{ item.icon }}</v-icon>
								</v-list-item>
							</template>
							<span>{{ item.trans }}</span>
						</v-tooltip>

						<v-tooltip v-else-if="item.menu && isMini" right :key="'mini-'+i">
							<template v-slot:activator="{ on }">
								<v-list-item v-on="on" id="module" active-class="primary--text"
									:exact="item.exact"
									:to="{path: '/'+item.router}"
									ripple
									class="mini-menu-item">
									<v-icon class="fs20i">{{ item.icon }}</v-icon>
								</v-list-item>
							</template>
							<span>{{ item.trans }}</span>
						</v-tooltip>

						<v-list-item v-else-if="item.menu" id="module" active-class="primary--text"
							:exact="item.exact"
							:to="{path: '/'+item.router}"
							ripple
							:key="i">
							<v-list-item-action>
								<v-icon class="fs20i">{{ item.icon }}</v-icon>
							</v-list-item-action>
							<v-list-item-content class="item-menu">
								<v-list-item-title>
									{{ item.trans }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
					<v-divider></v-divider>
					<v-tooltip right :disabled="!isMini">
						<template v-slot:activator="{ on }">
							<v-list-item v-on="on" id="module" ripple @click="openWidget" :class="{'mini-menu-item': isMini}">
								<v-list-item-action v-if="!isMini">
									<v-icon color="primary" class="fs20i">help</v-icon>
								</v-list-item-action>
								<v-icon v-else color="primary" class="fs20i">help</v-icon>
								<v-list-item-content v-if="!isMini" class="item-menu">
									<v-list-item-title>
										Aiuto
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</template>
						<span>Aiuto</span>
					</v-tooltip>
					<v-tooltip right :disabled="!isMini">
						<template v-slot:activator="{ on }">
							<v-list-item v-on="on" id="module" ripple @click="logoutDialog = true" :class="{'mini-menu-item': isMini}">
								<v-list-item-action v-if="!isMini">
									<v-icon color="red" class="fs20i">mdi-exit-to-app</v-icon>
								</v-list-item-action>
								<v-icon v-else color="red" class="fs20i">mdi-exit-to-app</v-icon>
								<v-list-item-content v-if="!isMini" class="red--text item-menu">
									<v-list-item-title>
										Esci
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</template>
						<span>Esci</span>
					</v-tooltip>
				</v-list>
			</v-navigation-drawer>

			<v-app-bar
				class="elevation-2"
				:class="$eventBusUtility.iconAppBarColor"
				fixed
				app clipped
				clipped-left clipped-right
				:color="headerColor"
				v-if="$store.getters.isAuthenticated">

					<v-btn
						icon
						class="ml-0 mr-1"
						v-if="$store.getters.isAuthenticated && ! backButton()"
						@click.stop="toggleDrawer" >
						<v-icon :class="$eventBusUtility.iconAppBarColor">menu</v-icon>
					</v-btn>
					
					<!-- <v-app-bar-nav-icon class="grey--text text--darken-3" 
						@click.stop="drawer = !drawer" 
						v-if="$store.getters.isAuthenticated && ! backButton()"
					></v-app-bar-nav-icon> -->
					<v-btn icon
						v-if="backButton()"
						@click="$router.go(-1)">
						<v-icon>arrow_back</v-icon>
					</v-btn>
					
					<v-img
						class="ml-2"
						:src="logo"
						contain
						height="36px"
						max-height="36px"
						max-width="40px"
					></v-img>
					
				<span v-if="!($vuetify.breakpoint.mdAndUp && breadcrumbShown && breadcrumbMode === 'appbar')" class="title ml-2 hidden-xs-only"><span class="fw300">{{ title }}</span></span>

				<!-- Breadcrumb inline nell'app bar (desktop): zero spazio verticale -->
				<breadcrumb v-if="$vuetify.breakpoint.mdAndUp && breadcrumbMode === 'appbar'" inline class="ml-3"></breadcrumb>

				<!-- TEMPORANEO: switch di confronto tra breadcrumb in app bar e sopra i tab.
					Sta sempre a fianco del breadcrumb: qui in modalita' 'appbar',
					il gemello nella barra sopra i tab in 'bar' -->
				<v-btn
					v-if="breadcrumbShown && breadcrumbMode === 'appbar' && $vuetify.breakpoint.mdAndUp"
					icon
					small
					class="ml-2"
					:title="'Breadcrumb: app bar (clicca per cambiare)'"
					@click="toggleBreadcrumbMode">
					<v-icon small>mdi-swap-horizontal</v-icon>
				</v-btn>
				
				<!-- Badge staging -->
				<v-chip
					v-if="isStaging"
					color="warning"
					text-color="white"
					x-small
					class="ml-2"
					label
				>
					STAGING
				</v-chip>
				<!-- Badge development -->
				<v-chip
					v-if="isDev"
					color="red"
					text-color="white"
					x-small
					class="ml-2"
					label
				>
					DEVELOPMENT
				</v-chip>

				<v-spacer></v-spacer>

				<global-search v-if="$store.getters.getSetting('global_search') && $vuetify.breakpoint.smAndUp"></global-search>

				<v-spacer></v-spacer>

				<v-tooltip bottom v-if="hasExternalHeaderBar && tempestBarLeader">
					<template v-slot:activator="{ on }">
						<v-btn v-on="on" icon @click="tempestChatDrawer = !tempestChatDrawer">
							<v-icon :class="$eventBusUtility.iconAppBarColor">mdi-phone-in-talk</v-icon>
						</v-btn>
					</template>
					<span>Finestra di gestione chiamata</span>
				</v-tooltip>

				<!-- Desktop view - show all icons -->
				<template v-if="$vuetify.breakpoint.mdAndUp">
					<color-mode @colorModeChanged="setLogo"></color-mode>

					<favorites-menu></favorites-menu>

					<daily-timecard v-if="$store.getters.checkModulePermissions('timecards')"></daily-timecard>

					<v-tooltip bottom v-if="canSelfClock">
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" icon @click="selfClockDialog = true">
								<v-icon :class="$eventBusUtility.iconAppBarColor">mdi-fingerprint</v-icon>
							</v-btn>
						</template>
						<span>Timbra ora</span>
					</v-tooltip>

					<releases-menu></releases-menu>

					<notifications-menu></notifications-menu>

					<sync-menu v-if="$store.getters.checkModelPermissions('setting')"></sync-menu>

					<v-tooltip bottom v-if="$store.getters.checkModelPermissions('yellolog')">
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" icon @click="$router.push({ name: 'yellologs' })" href="#/logs">
								<v-badge right overlap color="red" :content="$store.getters.yellologsCount > 99 ? '+99' : $store.getters.yellologsCount" :value="$store.getters.yellologsCount > 0">
									<v-icon :class="$eventBusUtility.iconAppBarColor">mdi-bug</v-icon>
								</v-badge>
							</v-btn>
						</template>
						<span>Log</span>
					</v-tooltip>
				</template>

				<!-- Mobile view - show only essential icons and more menu -->
				<template v-else>
					<favorites-menu></favorites-menu>

					<notifications-menu></notifications-menu>

					<more-menu @colorModeChanged="setLogo" @openSelfClock="selfClockDialog = true"></more-menu>
				</template>
			</v-app-bar>

			<v-dialog v-model="selfClockDialog" max-width="500" content-class="round-card">
				<hr-clock-widget v-if="selfClockDialog" self-service embedded></hr-clock-widget>
			</v-dialog>

			<v-system-bar
				v-if="isImpersonating && $store.getters.isAuthenticated"
				color="warning"
				dark
				app
				height="32"
			>
				<v-icon small>mdi-account-arrow-right</v-icon>
				<span class="ml-2 caption fw500">Sessione di impersonazione — {{ $store.getters.getProfile.name }}</span>
				<v-spacer></v-spacer>
				<v-btn x-small text @click="endImpersonation">Termina sessione</v-btn>
			</v-system-bar>

			<!-- z-index 5: la barra e' larga quanto la pagina, deve restare sotto
			     alla sidebar dei filtri (6) invece di coprirla, ma sopra ai tab
			     sticky e al breadcrumb (4), che altrimenti coprono i menu a
			     tendina quando l'iframe si allarga. -->
			<div>
				<iframe v-if="hasExternalHeaderBar && tempestBarLeader"
					id="myIframe"
					class="main-toolbar-iframe"
					allow="camera; microphone; autoplay; clipboard-read; clipboard-write; fullscreen"
					:src="$store.getters.getTempestToolbarUrl"
					@load="tempestBarCaricata('barra')"
					:style="{
						'left': drawer ? ($vuetify.breakpoint.smAndDown ? '280px' : (isMini ? '56px' : '250px')) : '0',
						'transition': 'left 0.2s cubic-bezier(0.2, 0, 0.2, 1), width 0.2s cubic-bezier(0.2, 0, 0.2, 1)',
						'width': drawer ? ($vuetify.breakpoint.smAndDown ? 'calc(100% - 280px)' : (isMini ? 'calc(100% - 56px)' : 'calc(100% - 250px)')) : '100%',
						'top': '64px',
						'position': 'fixed',
						'z-index': '5',
						'height': iFrameHeight,
					}">
				</iframe>

				<!-- Un agente Tempest puo' avere una sola sessione attiva: con la
				     barra in piu' schede l'ultima scalza le precedenti e le
				     rimette in pausa. Qui la barra c'e' in un'altra scheda. -->
				<div v-else-if="hasExternalHeaderBar"
					class="d-flex align-center px-4 background-2"
					:style="{
						'left': drawer ? ($vuetify.breakpoint.smAndDown ? '280px' : (isMini ? '56px' : '250px')) : '0',
						'transition': 'left 0.2s cubic-bezier(0.2, 0, 0.2, 1), width 0.2s cubic-bezier(0.2, 0, 0.2, 1)',
						'width': drawer ? ($vuetify.breakpoint.smAndDown ? 'calc(100% - 280px)' : (isMini ? 'calc(100% - 56px)' : 'calc(100% - 250px)')) : '100%',
						'top': '64px',
						'position': 'fixed',
						'z-index': '5',
						'height': '56px',
					}">
					<v-icon small class="mr-2">mdi-phone-off-outline</v-icon>
					<span class="caption">Barra operatore attiva in un'altra scheda</span>
					<v-spacer></v-spacer>
					<v-btn small text color="primary" @click="tempestTakeoverDialog = true">Spostala qui</v-btn>
				</div>
			</div>

			<v-dialog v-model="tempestTakeoverDialog" max-width="520" content-class="round-card">
				<v-card class="background-2 round-card">
					<v-card-title class="subtitle-1">Spostare qui la barra operatore?</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pt-4 body-2">
						La barra verra' chiusa nell'altra scheda e ricaricata qui. Il centralino
						eseguira' un nuovo accesso, quindi il tuo stato tornera' in pausa e dovrai
						rimetterti disponibile.
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="tempestTakeoverDialog = false">Annulla</v-btn>
						<v-btn text color="info" @click="takeTempestBar">Spostala qui</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-navigation-drawer
				v-if="hasExternalHeaderBar && tempestBarLeader"
				v-model="tempestChatDrawer"
				app
				right
				temporary
				width="560">
				<div class="d-flex flex-column" style="height: 100%;">
					<v-toolbar flat dense class="flex-grow-0">
						<v-icon left>mdi-phone-in-talk</v-icon>
						<v-toolbar-title class="subtitle-2">Gestione chiamata</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon @click="tempestChatDrawer = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar>
					<v-divider></v-divider>
					<!-- Tenuto montato anche a pannello chiuso: ricaricarlo a ogni
					     apertura rifarebbe login e registrazione dell'interno -->
					<iframe
						ref="tempestChatIframe"
						allow="camera; microphone; autoplay; clipboard-read; clipboard-write; fullscreen"
						:src="$store.getters.getTempestChatSectionUrl"
						@load="tempestBarCaricata('pannello')"
						class="flex-grow-1"
						style="width: 100%; border: 0; min-height: 0;">
					</iframe>
				</div>
			</v-navigation-drawer>

			<!-- Chiamata in arrivo: la barra annuncia il numero prima che
			     l'operatore risponda, cosi' la scheda e' gia' li' pronta -->
			<v-card
				v-if="incomingCall"
				ref="incomingCallCard"
				class="incoming-call-card"
				:style="incomingCallStyle"
				elevation="8"
				width="360">
				<v-toolbar
					flat
					dense
					class="incoming-call-handle"
					:color="headerColor"
					:class="$eventBusUtility.iconAppBarColor"
					@pointerdown.native="startIncomingCallDrag">
					<v-icon left :class="$eventBusUtility.iconAppBarColor">mdi-phone-incoming</v-icon>
					<v-toolbar-title class="subtitle-2">Chiamata in arrivo</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon small @click="incomingCall = null">
						<v-icon small :class="$eventBusUtility.iconAppBarColor">mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<v-card-text class="py-2">
					<div class="subtitle-1 fw500">{{ incomingCall.number || 'Numero non comunicato' }}</div>
					<div v-if="incomingCall.group" class="caption grey--text">{{ incomingCall.group }}</div>
				</v-card-text>

				<v-divider></v-divider>

				<div v-if="incomingCall.loading" class="pa-4 text-center">
					<v-progress-circular indeterminate size="24" color="primary"></v-progress-circular>
				</div>

				<v-list v-else-if="incomingCall.matches.length" dense class="py-0 incoming-call-list">
					<v-list-item
						v-for="match in incomingCallVisibleMatches"
						:key="match.business + '-' + match.id"
						:input-value="match.esatta"
						color="primary"
						@click="openIncomingCallMatch(match)">
						<v-list-item-content>
							<v-list-item-title>{{ match.nome }}</v-list-item-title>
							<v-list-item-subtitle>
								{{ $trans(match.tipo) }}<template v-if="match.telefono"> · {{ match.telefono }}</template>
								<template v-if="match.esatta"> · scheda della chiamata</template>
							</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-action>
							<v-icon small>mdi-chevron-right</v-icon>
						</v-list-item-action>
					</v-list-item>

					<v-list-item
						v-if="incomingCallVisibleMatches.length < incomingCall.matches.length"
						@click="incomingCall.mostraAltre = true">
						<v-list-item-content>
							<v-list-item-subtitle class="primary--text">
								Altre anagrafiche con lo stesso numero ({{ incomingCall.matches.length - incomingCallVisibleMatches.length }})
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>

				<v-card-text v-else class="py-3">
					<span class="grey--text">Nessuna anagrafica con questo numero.</span>
				</v-card-text>

				<v-divider v-if="!incomingCall.loading && !incomingCall.matches.length"></v-divider>

				<v-card-actions v-if="!incomingCall.loading && !incomingCall.matches.length">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="createLeadFromIncomingCall">
						<v-icon left small>mdi-account-plus</v-icon>
						Crea lead
					</v-btn>
				</v-card-actions>
			</v-card>

			<!-- Breadcrumb moved inside v-main to respect layout hierarchy -->

			<v-fade-transition>
				<centered-loader v-show="$store.getters.progress" :size="50" color="primary" ></centered-loader>
			</v-fade-transition>

			<!-- Lo spazio della sidebar dei filtri lo comanda il drawer stesso: si
			     registra con `app` quando e' fissato e si deregistra da solo quando la
			     sezione senza sidebar lo smonta (per questo non serve piu' indovinare
			     nulla dal nome della rotta). Il valore riservato dalla Crud copre solo
			     l'attesa fra il primo render e la comparsa del drawer. -->
			<v-main
				class="background-1 main-clip-x"
				:style="{
					'padding-right': filterDrawerWidth + 'px',
					'transition': 'padding-right 0.2s cubic-bezier(0.2, 0, 0.2, 1)'
				}">

				<!-- sticky: resta sotto l'app bar mentre la pagina scorre; i tab di navigazione
				     (.tabs-route) si fermano subito sotto di lei tramite --breadcrumb-h -->
				<div
					v-if="breadcrumbBarInMain"
					ref="breadcrumbBar"
					class="breadcrumb-sticky"
					:style="{'margin-top': hasExternalHeaderBar ? '64px' : '0'}">
					<breadcrumb></breadcrumb>
					<!-- TEMPORANEO: gemello dello switch dell'app bar, a fianco del
						breadcrumb quando la barra sta sopra i tab (solo desktop:
						sotto md la modalita' non ha effetto) -->
					<v-btn
						v-if="$vuetify.breakpoint.mdAndUp"
						icon
						x-small
						style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%)"
						:title="'Breadcrumb: sopra i tab (clicca per cambiare)'"
						@click="toggleBreadcrumbMode">
						<v-icon small>mdi-swap-horizontal</v-icon>
					</v-btn>
				</div>

				<v-container
					fluid
					style="height: 100%;"
					:style="{'padding-top': hasExternalHeaderBar ? (breadcrumbBarInMain ? '0' : '64px') : (breadcrumbBarInMain ? '0' : '8px')}"
					:class="{'pa-0': $vuetify.breakpoint.smAndDown, 'px-2 pb-0': $vuetify.breakpoint.mdAndUp, 'fill-height': $route.path == '/login'}">
					<!-- status e' falso finche' non c'e' un utente caricato: le rotte che
						 servono proprio ad ottenerlo vanno elencate qui, altrimenti restano
						 sullo spinner senza montare mai. /sso/callback e' una di queste. -->
					<template v-if="status || $route.path == '/login' || $route.path == '/impersonate' || $route.path == '/sso/callback'">

						<router-view v-if="!$route.meta.noTabs" :key="$route.fullPath"></router-view>
						<template v-else>
							<v-slide-y-reverse-transition>
								<router-view v-show="!$store.getters.progress" :key="$route.fullPath"></router-view>
							</v-slide-y-reverse-transition>
						</template>

					</template>
					<v-dialog v-model="logoutDialog" max-width="600" persistent>
						<v-card class="background-2 round-card">
							<v-card-title primary-title class="subtitle-1 background-2">Logout</v-card-title>
							<v-divider></v-divider>
							<v-card-text style="min-height: 100px;" class="pt-4 body-2">Vuoi davvero uscire?</v-card-text>
							<v-divider></v-divider>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn text color="info" @click.native.stop="logoutDialog = false" >Annulla
								</v-btn>
								<v-btn text color="error" @click.native.stop="logout()">Esci
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-container>
			</v-main>

		</template>

		<template v-else>
			<router-view></router-view>
		</template>

		<v-snackbar
			:timeout="$store.getters.snackbar.timeout"
			:color="$store.getters.snackbar.color"
			v-model="snackbarValue">
			<span class="fw500">{{ $store.getters.snackbar.text }}</span>
      		<template v-slot:action="{ attrs }">
				<v-btn dark icon v-bind="attrs" @click.native="$store.commit('setSnackbar', {timeout: 6000, text: '', value: false, color: ''})">
					<v-icon>clear</v-icon>
				</v-btn>
      		</template>
		</v-snackbar>

		<v-snackbar
			v-model="showUpdateSnackbar"
			:timeout="-1"
			color="info"
			bottom>
			<v-icon left>mdi-update</v-icon>
			<span class="fw500">Nuova versione disponibile</span>
			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="applyUpdate">
					Aggiorna
				</v-btn>
				<v-btn icon v-bind="attrs" @click="showUpdateSnackbar = false">
					<v-icon>clear</v-icon>
				</v-btn>
			</template>
		</v-snackbar>

		<maintenance-overlay></maintenance-overlay>

		<notification-snackbars></notification-snackbars>

		<csv-exports-panel v-if="$store.getters.isAuthenticated"></csv-exports-panel>

		<support-request-dialog
			:open="supportDialog"
			@close="supportDialog = false">
		</support-request-dialog>

	</v-app>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import GlobalSearch from '@/GlobalSearch'
import ColorMode from '@/components/common/ColorMode'
import FavoritesMenu from '@/components/FavoritesMenu'
import MoreMenu from '@/components/MoreMenu'
import ReleasesMenu from '@/components/common/ReleasesMenu'
import SupportRequestDialog from '@/components/common/SupportRequestDialog'
import CenteredLoader from '@/components/common/CenteredLoader'
import NotificationsMenu from '@/components/common/NotificationsMenu'
import SyncMenu from '@/components/common/SyncMenu'
import DailyTimecard from '@/components/modules/timecards/DailyTimecard'
import HrClockWidget from '@/components/modules/hr/HrClockWidget'
import Breadcrumb from '@/components/common/Breadcrumb'
import MaintenanceOverlay from '@/components/common/MaintenanceOverlay'
import NotificationSnackbars from '@/components/common/NotificationSnackbars'
import CsvExportsPanel from '@/components/common/CsvExportsPanel'
import AppCustomizationMixin from '@/mixins/AppCustomizationMixin'
import { filtersDrawerWidth } from '@/utils/filtersDrawer'
import { schedaDellaChiamata, propostePerChiamata } from '@/utils/tempestIncomingCall'

/*
 * Sigla della scheda del browser per il registro della barra operatore:
 * resta la stessa se la pagina viene ricaricata, cosi' nel Log si riconosce
 * quale scheda ha montato la barra.
 */
function siglaSchedaBarra() {
	const nuova = Math.random().toString(36).slice(2, 10)
	try {
		let sigla = sessionStorage.getItem('tempest_bar_scheda')
		if (!sigla) {
			sigla = nuova
			sessionStorage.setItem('tempest_bar_scheda', sigla)
		}
		return sigla
	} catch (e) {
		return nuova
	}
}

export default {
	mixins: [AppCustomizationMixin],
	components: {
		ColorMode,
		FavoritesMenu,
		MoreMenu,
		ReleasesMenu,
		DailyTimecard,
		HrClockWidget,
	    CenteredLoader,
		GlobalSearch,
	    NotificationsMenu,
		SyncMenu,
		Breadcrumb,
		MaintenanceOverlay,
		NotificationSnackbars,
		CsvExportsPanel,
		SupportRequestDialog
	},
	data() {
		return {
			drawer: false,
			miniDrawer: false,
			// Stato del menu sulle pagine che lo vogliono stretto (meta
			// compactDrawer): parte a icone a ogni ingresso e non tocca
			// quello delle altre pagine, che ritrovi com'era uscendo.
			compactMiniDrawer: true,
			// title, app_color, logo, headerColor now come from AppCustomizationMixin
			logoutDialog: false,
			supportDialog: false,
            isStaging: process.env.VUE_APP_STAGING == 'true' || window.location.hostname.includes('staging'),
			isDev: process.env.NODE_ENV == 'development',
			iFrameHeight: '56px',
			// Finestra di gestione chiamata: tastierino, tab e note. Sta in un
			// pannello laterale per non rubare spazio verticale a ogni pagina.
			tempestChatDrawer: false,

			// Chiamata in arrivo annunciata dalla barra: numero, esito della
			// ricerca in anagrafica e stato di caricamento
			incomingCall: null,

			// Posizione del riquadro quando l'operatore lo sposta: null vuol dire
			// dove lo mette il foglio di stile, in basso a destra
			incomingCallPosition: null,
			incomingCallDrag: null,
			// Solo la scheda che detiene il lock monta la barra: un agente
			// Tempest ha una sola sessione, e piu' schede si scalzano a vicenda
			tempestBarLeader: false,
			releaseTempestBar: null,
			tempestBarClaiming: false,
			tempestTakeoverDialog: false,
			// Registro della barra nel Log: ogni montaggio e' un nuovo accesso al
			// centralino, che rimette l'operatore in pausa. Motivo del prossimo
			// montaggio/smontaggio e caricamenti degli iframe nel montaggio corrente.
			tempestBarScheda: siglaSchedaBarra(),
			tempestBarMontaggi: 0,
			tempestBarMotivoMontaggio: null,
			tempestBarMotivoSmontaggio: null,
			tempestBarCaricamenti: { barra: 0, pannello: 0 },
			// Capacitor state
			appStateListener: null,
			backButtonListener: null,
			isImpersonating: localStorage.getItem('is_impersonating') === 'true',
			// TEMPORANEO: modalità breadcrumb per confronto ('appbar' | 'bar')
			breadcrumbMode: localStorage.getItem('breadcrumb_mode') || 'appbar',
			selfClockDialog: false,
		}
	},

	computed: {
		breadcrumbShown() {
			return this.$store.getters.isAuthenticated && this.$store.getters.breadcrumbVisible
		},
		// barra breadcrumb renderizzata dentro v-main (sm/xs, o modalità 'bar' su desktop)
		breadcrumbBarInMain() {
			return this.breadcrumbShown && (this.$vuetify.breakpoint.smAndDown || this.breadcrumbMode === 'bar')
		},
		snackbarValue: {
			get() {
				return this.$store.getters.snackbar.value
			},
			set(newValue) {
				this.$store.commit('setSnackbar', {timeout: 6000, text: '', value: newValue, color: ''})
			},
		},
		showUpdateSnackbar: {
			get() {
				return this.$store.getters.updateAvailable
			},
			set(newValue) {
				this.$store.commit('setUpdateAvailable', newValue)
			},
		},

		// Origine dell'iframe della barra, per validare i messaggi che invia
		tempestBarOrigin() {
			try {
				return new URL(this.$store.getters.getTempestIframeUrl).origin
			} catch (e) {
				return null
			}
		},

		// Variabili CSS dei tab di navigazione sticky (.tabs-route, vedi custom.css).
		// --app-top: app bar piu' barra operatore (56px, position fixed sotto l'app bar, non passa da
		//   $vuetify.application.top; a riposo e' sempre alta 56px, l'iframe si allarga solo col pannello chiamata).
		// --content-pt: padding-top del contenitore delle pagine (vedi sotto): .tabs-route lo annulla con un
		//   margine negativo e mette il proprio spazio sopra i tab, cosi' a riposo e incollati stanno alla
		//   stessa quota e allo scroll non si muovono.
		stickyVars() {
			return {
				'--app-top': (this.$vuetify.application.top + (this.hasExternalHeaderBar ? 56 : 0)) + 'px',
				'--content-pt': (this.breadcrumbBarInMain ? 0 : 8) + 'px'
			}
		},

		hasExternalHeaderBar() {
			// Anche l'autenticazione: dopo il logout permessi e dati utente
			// restano in memoria, e la barra rimaneva visibile e collegata al
			// centralino sopra la pagina di accesso, con l'operatore ancora
			// disponibile a ricevere chiamate.
			return this.$store.getters.isAuthenticated &&
				this.$store.getters.checkModulePermissions('callcenter') &&
				this.$store.getters.checkUserdata('show_tempest_bar')
		},

		// Letto solo a barra attiva: prima del caricamento dei dati utente il
		// getter non e' valutabile
		tempestToolbarUrl() {
			return this.hasExternalHeaderBar ? this.$store.getters.getTempestToolbarUrl : ''
		},

		/**
		 * Raggruppa le voci del modulo HR sotto un accordion "Risorse Umane".
		 * Le voci di altri moduli restano flat come prima.
		 *
		 * Inoltre: per il dropdown "Impostazioni" (item con permissions={...}
		 * dove ogni child ha solo trans+menu) sostituisce le ~7 voci HR
		 * sparse con una sola voce "Risorse Umane" → /hrsettings, e fixa
		 * il path bug originale (/settings+key per i moduli classici).
		 */
		groupedMenuItems() {
			const all = this.$store.getters.getPermissions || []
			const hrChildren = []
			const complianceChildren = []
			const others = []
			let hrInsertIdx = -1
			let complianceInsertIdx = -1
			all.forEach(item => {
				if (item.module === 'hr' && item.menu) {
					if (hrInsertIdx === -1) hrInsertIdx = others.length
					hrChildren.push(item)
					return
				}
				if (item.module === 'compliance' && item.menu) {
					if (complianceInsertIdx === -1) complianceInsertIdx = others.length
					complianceChildren.push(item)
					return
				}
				// Item Settings con permissions come oggetto: rielabora i children
				if (item.permissions && typeof item.permissions === 'object' && !Array.isArray(item.permissions)) {
					const settingsChildren = []
					let hrSettingsInserted = false
					Object.entries(item.permissions).forEach(([key, child]) => {
						if (!child || !child.menu) return
						const isHr = key.startsWith('hr') || (child.module === 'hr')
						if (isHr) {
							if (!hrSettingsInserted) {
								// No icon: si allinea allo stile delle altre voci del dropdown Impostazioni
								settingsChildren.push({
									trans: 'Risorse Umane',
									menu: true,
									router: 'hrsettings',
									_settingsKey: 'hrsettings',
								})
								hrSettingsInserted = true
							}
							return
						}
						// Le sezioni operative del modulo SGI/Compliance vivono solo nella
						// sidebar in alto (ramo item.module === 'compliance'): non vanno nel
						// dropdown Impostazioni.
						const isCompliance = key.startsWith('compliance') || (child.module === 'compliance')
						if (isCompliance) return
						// Il Drive non ha una pagina di impostazioni: i permessi
						// si configurano nei Ruoli e quelli per cartella dentro
						// il DMS stesso. Senza questo skip comparirebbe nel
						// dropdown una voce che punta a /settingsdrive, rotta
						// inesistente.
						if (key === 'drive' || child.module === 'drive') return
						// Pattern legacy /settings + key per i moduli classici
						settingsChildren.push({
							...child,
							_settingsKey: key,
							router: child.router || 'settings' + key,
						})
					})
					// Configuratore dell'app: solo per i clienti con l'app attiva
					if (this.$store.getters.isMobileEnabled) {
						settingsChildren.push({
							trans: 'Mobile',
							menu: true,
							router: 'settingsmobile',
							_settingsKey: 'settingsmobile',
						})
					}
					others.push({ ...item, _settingsItems: settingsChildren })
					return
				}
				others.push(item)
			})
			hrChildren.sort((a, b) => (a.order || 999) - (b.order || 999))
			const profile = this.$store.getters.getProfile || {}
			const hrModuleEnabled = !!profile.hr_module_enabled
			const userIsEmployee = !!profile.hr_employee_id
			const hrOnly = this.$store.getters.isHrOnly
			// "I miei dati" (self-service) visibile solo se utente è collegato a un dipendente.
			// In modalità "solo HR" è la home di tutti: chi non è collegato vede il banner.
			if (hrModuleEnabled && (userIsEmployee || hrOnly)) {
				hrChildren.unshift({
					trans: 'I miei dati',
					menu: true,
					router: 'hrme',
					icon: 'mdi-account-circle-outline',
				})
			}
			if (hrChildren.length > 0) {
				const hrGroup = {
					trans: 'Risorse Umane',
					icon: 'mdi-account-group',
					children: hrChildren,
					module: 'hr',
					router: 'hr',
				}
				others.splice(hrInsertIdx >= 0 ? hrInsertIdx : others.length, 0, hrGroup)
			}
			if (complianceChildren.length > 0) {
				complianceChildren.sort((a, b) => (a.order || 999) - (b.order || 999))
				const complianceGroup = {
					trans: 'SGI / Compliance',
					icon: 'mdi-shield-check',
					children: complianceChildren,
					module: 'compliance',
					router: 'compliance',
				}
				// hrInsertIdx può aver spostato gli indici: ricalcolo non necessario perché
				// lo splice HR inserisce un solo elemento; compensiamo se l'HR è prima.
				let idx = complianceInsertIdx >= 0 ? complianceInsertIdx : others.length
				if (hrChildren.length > 0 && hrInsertIdx >= 0 && hrInsertIdx <= idx) idx++
				others.splice(idx, 0, complianceGroup)
			}
			return hrOnly ? this.flattenMenuItems(others) : others
		},

		compactDrawerRoute() {
			return !!(this.$route.meta && this.$route.meta.compactDrawer)
		},

		isMini() {
			if (!this.$vuetify.breakpoint.mdAndUp) {
				return false
			}
			return this.compactDrawerRoute ? this.compactMiniDrawer : this.miniDrawer
		},

		filterDrawerWidth() {
			// $vuetify.application.right e' la larghezza che il drawer fissato ha
			// registrato: quando c'e' lui e' l'unica verita'.
			return this.$vuetify.application.right || this.$store.getters.filterDrawerReservedWidth
		},

		...mapGetters(['status']),

		canSelfClock() {
			const p = this.$store.getters.getProfile || {}
			return !!(p.hr_module_enabled && p.hr_employee_id)
		},

		// Quando la barra indica la scheda della chiamata si mostra solo quella:
		// le altre anagrafiche con lo stesso numero restano a un clic, nel caso
		// l'identificativo non sia quello giusto
		incomingCallVisibleMatches() {
			const matches = this.incomingCall ? this.incomingCall.matches : []

			if (this.incomingCall && this.incomingCall.mostraAltre) {
				return matches
			}

			const esatte = matches.filter(match => match.esatta)

			return esatte.length ? esatte : matches
		},

		// Finche' l'operatore non lo sposta, il riquadro sta dove lo mette il
		// foglio di stile; una volta spostato comanda la posizione scelta
		incomingCallStyle() {
			if (!this.incomingCallPosition) {
				return {}
			}

			return {
				left: this.incomingCallPosition.left + 'px',
				top: this.incomingCallPosition.top + 'px',
				right: 'auto',
				bottom: 'auto',
			}
		},

		// Computed property per ottenere il colore primary dal tema
		primaryColor() {
			return this.$vuetify.theme.currentTheme.primary
		}

	},

	watch: {
		/*
		 * Al logout la barra viene smontata: senza rilasciare il lock, le altre
		 * schede resterebbero in attesa di una barra che non esiste piu'.
		 */
		hasExternalHeaderBar: {
			immediate: true,
			handler(attiva) {
				if (attiva) {
					if (this.tempestBarMontaggi > 0 && !this.tempestBarMotivoMontaggio) {
						this.tempestBarMotivoMontaggio = 'riattivata'
					}
					this.claimTempestBar()
				} else if (this.releaseTempestBar) {
					this.tempestBarMotivoSmontaggio = this.motivoBarraDisattivata()
					this.releaseTempestBar()
				}
			},
		},

		tempestBarLeader(montata, eraMontata) {
			if (montata) {
				this.tempestBarMontaggi++
				this.tempestBarCaricamenti = { barra: 0, pannello: 0 }
				const motivo = this.tempestBarMotivoMontaggio
					|| (this.tempestBarMontaggi === 1 ? this.motivoAperturaPagina() : 'ripresa')
				this.tempestBarMotivoMontaggio = null
				this.logTempestBar('montata', motivo, { montaggio: String(this.tempestBarMontaggi) })
			} else if (eraMontata) {
				const motivo = this.tempestBarMotivoSmontaggio || 'non_indicato'
				this.tempestBarMotivoSmontaggio = null
				this.logTempestBar('smontata', motivo)
			}
		},

		/*
		 * L'indirizzo della barra contiene le credenziali: se cambia mentre e'
		 * montata l'iframe si ricarica, e per il centralino e' un nuovo accesso.
		 */
		tempestToolbarUrl(nuovo, vecchio) {
			// Solo da un indirizzo a un altro: quando la barra viene disattivata
			// l'indirizzo si svuota mentre la scheda risulta ancora titolare
			// (il lock si rilascia in modo asincrono), e lo smontaggio ha gia'
			// la sua voce
			if (this.tempestBarLeader && vecchio && nuovo && nuovo !== vecchio) {
				this.logTempestBar('indirizzo_cambiato', 'dati_utente')
			}
		},

    	'$route' (to, from) {
			if(to.name == 'login')
				this.drawer = false
			if (to.meta.compactDrawer && !(from.meta && from.meta.compactDrawer))
				this.compactMiniDrawer = true
			let title = this.title
			if(to.meta.title)
				title += ' - ' + this.$trans(to.meta.title)
			document.title = title

			// Aggiorna stato impersonazione al cambio route
			this.isImpersonating = localStorage.getItem('is_impersonating') === 'true'

			this.reserveFilterDrawerSpace(to)
    	},
		primaryColor(newColor) {
			document.documentElement.style.setProperty('--primary-color', newColor)
		},
		// il breadcrumb sopra i tab e' sticky: i tab si fermano sotto la sua altezza reale
		breadcrumbBarInMain: {
			immediate: true,
			handler() {
				this.$nextTick(this.observeBreadcrumbBar)
			}
		},
		stickyVars: {
			immediate: true,
			handler(vars) {
				Object.keys(vars).forEach(name => document.documentElement.style.setProperty(name, vars[name]))
			}
		}
	},
	
	mounted() {
		// Salva bypass token se presente nell'URL (per manutenzione) - scade dopo 1 ora
		if (this.$route.query.maintenance_bypass) {
			const bypassData = {
				token: this.$route.query.maintenance_bypass,
				expiry: Date.now() + (60 * 60 * 1000) // 1 ora
			}
			localStorage.setItem('maintenance_bypass', JSON.stringify(bypassData))
		}
		
    	window.addEventListener('offline', this.networkStatus)
    	window.addEventListener('online', this.networkStatus)

		this.reserveFilterDrawerSpace(this.$route)

		this.$eventBusUtility.$on('loggedIn', this.setCustomAppData)

		// Sempre in ascolto: al mount i dati utente non sono ancora caricati e
		// hasExternalHeaderBar risulterebbe falso, lasciando la barra senza
		// nessuno che ne riceva i messaggi di ridimensionamento. Il gestore
		// verifica comunque origine e finestra di provenienza.
		window.addEventListener('message', this.handleIframeMessage, false)

		this.$nextTick(() => {
			document.documentElement.style.setProperty('--primary-color', this.primaryColor)
		})
	},

	beforeDestroy() {
		if (this.breadcrumbObserver) {
			this.breadcrumbObserver.disconnect()
		}
		window.removeEventListener('offline', this.networkStatus)
		window.removeEventListener('online', this.networkStatus)
		window.removeEventListener('message', this.handleIframeMessage, false)

		if (this.releaseTempestBar) {
			// Dopo la distruzione il watcher non scatta piu': si registra qui
			this.logTempestBar('smontata', 'chiusura')
			this.releaseTempestBar()
		}

		this.stopIncomingCallDrag()

		// Rimuovi i listener Capacitor
		if (this.appStateListener && this.appStateListener.remove) {
			this.appStateListener.remove()
		}
		if (this.backButtonListener && this.backButtonListener.remove) {
			this.backButtonListener.remove()
		}
	},

	created () {
		this.getCustomAppData()

		// request notification permission for web
		this.requestWebNotificationPermission()

		this.$store.dispatch('CHECK_MOBILE')

		// Inizializza Capacitor quando l'app è pronta
		this.initializeCapacitor()

		if (this.$store.getters.isAuthenticated) {
			this.$store.dispatch('USER_REQUEST').then(() => {
				this.drawer = this.$vuetify.breakpoint.lgAndUp
				this.miniDrawer = false
			})
		}
	},

	methods: {
		/**
		 * Modalità "solo HR": le voci dei moduli al primo livello, senza gruppi
		 * da aprire. Restano nel dropdown solo le Impostazioni, da cui esce la
		 * Dashboard; sparisce anche la sua voce di menu (rimanderebbe comunque
		 * a I miei dati).
		 */
		flattenMenuItems(items) {
			const flat = []
			items.forEach(item => {
				if (item.router === 'dashboard') return
				if (item._settingsItems) {
					flat.push({ ...item, _settingsItems: item._settingsItems.filter(child => child._settingsKey !== 'dashboard') })
					return
				}
				if (item.children) {
					item.children.forEach(child => {
						if (child.menu) flat.push({ ...child, icon: child.icon || item.icon })
					})
					return
				}
				flat.push(item)
			})
			return flat
		},

		// setCustomAppData, getCustomAppData, setLogo methods now come from AppCustomizationMixin

		observeBreadcrumbBar() {
			if (this.breadcrumbObserver) {
				this.breadcrumbObserver.disconnect()
				this.breadcrumbObserver = null
			}
			const el = this.$refs.breadcrumbBar
			const setHeight = (h) => document.documentElement.style.setProperty('--breadcrumb-h', h + 'px')
			if (!el || typeof ResizeObserver === 'undefined') {
				setHeight(el ? el.offsetHeight : 0)
				return
			}
			this.breadcrumbObserver = new ResizeObserver(() => setHeight(el.offsetHeight))
			this.breadcrumbObserver.observe(el)
		},

		// TEMPORANEO: switch di confronto tra breadcrumb in app bar e sopra i tab
		toggleBreadcrumbMode() {
			this.breadcrumbMode = this.breadcrumbMode === 'appbar' ? 'bar' : 'appbar'
			localStorage.setItem('breadcrumb_mode', this.breadcrumbMode)
		},

		toggleDrawer() {
			if (this.$vuetify.breakpoint.mdAndUp && this.compactDrawerRoute) {
				this.compactMiniDrawer = !this.compactMiniDrawer
			} else if (this.$vuetify.breakpoint.mdAndUp) {
				this.miniDrawer = !this.miniDrawer
			} else {
				this.drawer = !this.drawer
			}
		},

		endImpersonation() {
			localStorage.removeItem('is_impersonating')
			this.isImpersonating = false
			this.$store.dispatch('AUTH_LOGOUT')
		},

		/**
		 * Richiede il permesso per le notifiche web (browser)
		 */
		requestWebNotificationPermission() {
			try {
				if (!('Notification' in window)) {
					console.log('Desktop notifications not available in your browser.')
				} else if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {
					Notification.requestPermission()
				}
			} catch (error) {
				console.warn('Errore richiesta permesso notifiche web:', error)
			}
		},

		/**
		 * Inizializza i servizi Capacitor
		 */
		async initializeCapacitor() {
			// Inizializza OneSignal per le notifiche push
			if (this.$capacitor.isNative) {
				await this.initializeOneSignal()
				this.setupCapacitorListeners()
			}
		},

		/**
		 * Inizializza OneSignal per le notifiche push
		 */
		async initializeOneSignal() {
			try {
				// Inizializza il servizio OneSignal
				await this.$oneSignal.initialize()

				// Richiedi il permesso per le notifiche (iOS e Android 13+)
				await this.$oneSignal.requestPermission()

				// Imposta l'handler per quando una notifica viene aperta
				this.$oneSignal.setNotificationOpenedHandler((data) => {
					const additionalData = data.additionalData || {}

					// Se la notifica contiene modelDef e modelDefId, naviga a quella pagina
					if (additionalData.modelDef && additionalData.modelDefId) {
						this.$eventBusUtility.goTo(
							this.$router,
							additionalData.modelDef + '-show',
							additionalData.modelDefId
						)
					}
				})

				// Imposta l'handler per le notifiche ricevute in foreground
				this.$oneSignal.setNotificationReceivedHandler((data) => {
					console.log('Notifica ricevuta in foreground:', data)
				})

				console.log('OneSignal inizializzato con successo')
			} catch (error) {
				console.error('Errore inizializzazione OneSignal:', error)
			}
		},

		/**
		 * Configura i listener per gli eventi Capacitor
		 */
		setupCapacitorListeners() {
			// Listener per lo stato dell'app (foreground/background)
			this.appStateListener = this.$capacitor.addAppStateListener((isActive) => {
				if (isActive) {
					this.onResume()
				} else {
					this.onPause()
				}
			})

			// Listener per il pulsante back su Android
			if (this.$capacitor.isAndroid) {
				this.backButtonListener = this.$capacitor.addBackButtonListener(() => {
					this.onBackKeyDown()
				})
			}

			// Listener per la gestione degli URL (deep linking)
			this.$capacitor.addAppUrlOpenListener((event) => {
				if (event.url) {
					// Gestisci deep link yello://
					const url = event.url.replace('yello://', '')
					if (url) {
						this.$router.replace(url)
					}
				}
			})
		},

		/**
		 * Un agente Tempest puo' essere collegato una sola volta: se la barra
		 * viene caricata in piu' schede, ogni nuovo accesso scalza il precedente
		 * e riporta l'operatore in pausa. Una sola scheda per volta la monta,
		 * decisa con un lock esclusivo del browser: quando quella scheda si
		 * chiude il lock si libera da solo e un'altra prende il suo posto.
		 *
		 * @param {boolean} steal sottrae il lock alla scheda che lo detiene
		 */
		claimTempestBar(steal = false) {
			// Una richiesta per volta: senza guardia la scheda finirebbe in coda
			// piu' volte e riprenderebbe la barra subito dopo averla ceduta
			if (this.tempestBarClaiming && !steal) {
				return
			}
			this.tempestBarClaiming = true

			if (!navigator.locks) {
				// Senza l'API restiamo al comportamento precedente
				this.tempestBarClaiming = false
				this.tempestBarLeader = true
				return
			}

			navigator.locks.request('tempest-operator-bar', { steal }, () => {
				this.tempestBarLeader = true
				return new Promise(resolve => { this.releaseTempestBar = resolve })
			}).then(() => {
				this.tempestBarLeader = false
				this.releaseTempestBar = null
				this.tempestBarClaiming = false
				this.iFrameHeight = '56px'
			}).catch(() => {
				// Il lock ci e' stato sottratto da un'altra scheda: si torna in
				// coda, cosi' la barra ricompare qui se quella scheda si chiude
				this.tempestBarMotivoSmontaggio = 'sottratta_da_altra_scheda'
				this.tempestBarMotivoMontaggio = 'ripresa_da_altra_scheda'
				this.tempestBarLeader = false
				this.releaseTempestBar = null
				this.tempestBarClaiming = false
				this.iFrameHeight = '56px'
				this.claimTempestBar()
			})
		},

		takeTempestBar() {
			this.tempestTakeoverDialog = false
			this.tempestBarMotivoMontaggio = 'spostata_qui'
			this.claimTempestBar(true)
		},

		/*
		 * Registra nel Log un evento della barra operatore, per confrontarlo
		 * con le pause registrate dal centralino. Diagnostica pura: un errore
		 * non deve mai arrivare all'operatore.
		 */
		logTempestBar(evento, motivo, dettagli = {}) {
			// Senza sessione (logout) la richiesta non passerebbe comunque
			if (!this.$store.getters.isAuthenticated) {
				return
			}

			this.axios.post('tempest-bar-events', {
				evento: evento,
				motivo: motivo,
				scheda: this.tempestBarScheda,
				dettagli: Object.assign({ pagina_visibile: document.visibilityState === 'visible' ? 'si' : 'no' }, dettagli),
			}, { silent: true }).catch(() => {})
		},

		/*
		 * Il primo caricamento di ogni iframe e' quello del montaggio; i
		 * successivi sono ricaricamenti avvenuti a barra montata, che per il
		 * centralino possono essere un nuovo accesso.
		 */
		tempestBarCaricata(iframe) {
			this.tempestBarCaricamenti[iframe]++

			if (this.tempestBarCaricamenti[iframe] > 1) {
				this.logTempestBar('ricaricata', 'iframe_' + iframe, {
					caricamento: String(this.tempestBarCaricamenti[iframe]),
				})
			}
		},

		motivoAperturaPagina() {
			const navigazione = window.performance && window.performance.getEntriesByType
				? window.performance.getEntriesByType('navigation')[0]
				: null

			return navigazione && navigazione.type === 'reload' ? 'ricarica_pagina' : 'apertura_pagina'
		},

		/*
		 * Quale delle condizioni della barra e' venuta meno: un permesso o un
		 * dato utente che sparisce per un attimo (es. durante il ricaricamento
		 * dei dati utente) smonta e rimonta la barra.
		 */
		motivoBarraDisattivata() {
			if (!this.$store.getters.isAuthenticated) {
				return 'logout'
			}
			if (!this.$store.getters.checkModulePermissions('callcenter')) {
				return 'permessi_modulo'
			}
			return 'impostazione_utente'
		},

		handleIframeMessage(event) {
			// L'origine da accettare e' quella della barra, non la nostra: GMH e
			// Tempest stanno su domini diversi, ed e' il motivo per cui la barra
			// vuole `parent_origin` negli URL degli iframe.
			if (!event.data || !event.data.from || event.origin !== this.tempestBarOrigin) {
				return
			}

			// Solo dai due iframe della barra: l'origine da sola non basta, una
			// qualsiasi finestra di quel dominio potrebbe inviare messaggi
			const toolbar = document.getElementById('myIframe')
			const chat = this.$refs.tempestChatIframe

			if (event.source !== (toolbar && toolbar.contentWindow)
				&& event.source !== (chat && chat.contentWindow)) {
				return
			}

			// Il campo si chiama toolbar_height; `height` e' il nome usato in
			// alcuni esempi ed e' tenuto come ripiego
			const { from, type } = event.data
			const raw = event.data.toolbar_height !== undefined ? event.data.toolbar_height : event.data.height
			const height = Number(raw)

			// Lo squillo lo annuncia il container che gestisce il telefono, che
			// puo' essere l'uno o l'altro iframe: si accettano entrambi e la
			// duplicazione la assorbe handleIncomingCall
			if (type === 'phone_ring_in') {
				this.handleIncomingCall(event.data)
				return
			}

			if (from === 'main_toolbar') {
				switch (type) {
					case 'set_toolbar_height':
						// Solo altezze positive e plausibili: uno zero
						// occasionale, che la barra invia mentre si ricompone,
						// la farebbe sparire dalla pagina
						if (Number.isFinite(height) && height > 0 && height <= 2000) {
							this.iFrameHeight = height + 'px'
						}
						break
					case 'toolbar_extend':
					case 'VIDEO_XHR_CANDIDATE':
						this.iFrameHeight = '600px'
						break
				}
			}
		},

		/*
		 * Chiamata in arrivo: il numero del chiamante arriva dentro il testo del
		 * popup ACD ("Telefono: +39..."), l'unico posto in cui la barra lo
		 * comunica, e arriva mentre il telefono squilla: la scheda e' quindi
		 * gia' proposta prima che l'operatore risponda. Le chiamate delle
		 * campagne portano anche la scheda da cui sono partite (var_info.lead):
		 * quella va in cima, perche' lo stesso numero puo' stare su piu'
		 * anagrafiche.
		 */
		handleIncomingCall(data) {
			const number = this.extractIncomingNumber(data.acd_popup)
			const scheda = schedaDellaChiamata(data.var_info)
			const chiave = number || (scheda ? scheda.tipo + ':' + scheda.id : null)

			// Il secondo iframe annuncia la stessa chiamata: la scheda e' gia' li'
			if (!chiave || (this.incomingCall && this.incomingCall.chiave === chiave)) {
				return
			}

			this.incomingCall = {
				chiave: chiave,
				number: number,
				scheda: scheda,
				group: data.acd_group || null,
				matches: [],
				mostraAltre: false,
				loading: true,
			}

			// Il comando per rispondere e' dentro il pannello della barra, che
			// resta caricato ma nascosto: senza aprirlo l'operatore non ha modo
			// di andare in linea. Si apre da soli, non si chiude da soli: a
			// chiamata in corso i comandi devono restare a portata di mano.
			if (this.hasExternalHeaderBar && this.tempestBarLeader) {
				this.tempestChatDrawer = true
			}

			const mostra = trovate => {
				if (this.incomingCall && this.incomingCall.chiave === chiave) {
					this.incomingCall.matches = propostePerChiamata(trovate, scheda, number)
					this.incomingCall.loading = false
				}
			}

			// Senza numero resta la sola scheda indicata dalla barra
			if (!number) {
				mostra([])
				return
			}

			this.axios.get('business-by-phone', { params: { number: number } }).then(response => {
				mostra(response.data.data || [])
			}).catch(() => {
				// Senza esito la scheda resta con la proposta di creazione, o con
				// quella indicata dalla barra: e' comunque meglio dello sparire
				// mentre il telefono squilla
				mostra([])
			})
		},

		/*
		 * Il riquadro si trascina dall'intestazione: puo' capitare sopra il campo
		 * su cui l'operatore sta scrivendo mentre parla, e chiuderlo vorrebbe
		 * dire perdere il riferimento alla scheda. Si usano i pointer event, che
		 * coprono mouse e tocco con lo stesso codice.
		 */
		startIncomingCallDrag(event) {
			const card = this.$refs.incomingCallCard

			// Il pulsante di chiusura sta nell'intestazione: partendo da li' il
			// preventDefault gli mangerebbe il click
			if (!card || event.button > 0 || event.target.closest('.v-btn')) {
				return
			}

			const rect = card.$el.getBoundingClientRect()

			this.incomingCallDrag = {
				scartoX: event.clientX - rect.left,
				scartoY: event.clientY - rect.top,
			}

			// Si parte dalla posizione attuale, altrimenti al primo movimento
			// il riquadro salterebbe
			this.incomingCallPosition = { left: rect.left, top: rect.top }

			event.preventDefault()

			window.addEventListener('pointermove', this.onIncomingCallDrag)
			window.addEventListener('pointerup', this.stopIncomingCallDrag)
		},

		onIncomingCallDrag(event) {
			const card = this.$refs.incomingCallCard

			if (!this.incomingCallDrag || !card) {
				return
			}

			const rect = card.$el.getBoundingClientRect()
			const margine = 8

			// Trattenuto dentro la finestra: trascinato fuori non si
			// recupererebbe piu'. Il limite non scende sotto il margine: su una
			// finestra piu' stretta del riquadro sarebbe negativo, e lo
			// spingerebbe fuori dal lato opposto.
			const limiteX = Math.max(margine, window.innerWidth - rect.width - margine)
			const limiteY = Math.max(margine, window.innerHeight - rect.height - margine)

			this.incomingCallPosition = {
				left: Math.min(Math.max(event.clientX - this.incomingCallDrag.scartoX, margine), limiteX),
				top: Math.min(Math.max(event.clientY - this.incomingCallDrag.scartoY, margine), limiteY),
			}
		},

		stopIncomingCallDrag() {
			this.incomingCallDrag = null

			window.removeEventListener('pointermove', this.onIncomingCallDrag)
			window.removeEventListener('pointerup', this.stopIncomingCallDrag)
		},

		extractIncomingNumber(popup) {
			const match = String(popup || '').match(/\+?[\d][\d\s\-./]{5,}/)

			return match ? match[0].trim() : null
		},

		openIncomingCallMatch(match) {
			this.$eventBusUtility.goToBusiness(this.$router, match.business, match.id)
			this.incomingCall = null
		},

		createLeadFromIncomingCall() {
			this.$eventBusUtility.goTo(this.$router, 'leads-create', null, {
				primary_telephone: this.incomingCall.number,
			})
			this.incomingCall = null
		},

		/*
		 * La sidebar dei filtri nasce solo dopo la info API della sezione: senza
		 * questa prenotazione la pagina si aprirebbe a tutta larghezza per poi
		 * restringersi. Le sezioni che ce l'hanno sono quelle servite dalla Crud,
		 * che dichiara il proprio modelDef nelle props della rotta; per tutte le
		 * altre (impostazioni, dettagli, dashboard...) la prenotazione va a zero,
		 * altrimenti resterebbe lo spazio vuoto della sidebar.
		 */
		reserveFilterDrawerSpace(route) {
			const crudRecord = route.matched.find(record => {
				const component = record.components && record.components.default
				return component && component.name === 'crud'
			})
			const modelDef = this.modelDefOfRecord(crudRecord, route)

			const pinned = !!modelDef &&
				localStorage.getItem('filter_drawer_pinned_' + modelDef) === 'true' &&
				this.$vuetify.breakpoint.mdAndUp

			this.$store.commit('setFilterDrawerReservedWidth', pinned ? filtersDrawerWidth(this.$vuetify) : 0)
		},

		/*
		 * Le rotte Crud dichiarano le props come oggetto piatto oppure, quando
		 * hanno bisogno dei parametri (i sotto-elenchi di un dettaglio), come
		 * funzione: la chiamiamo come farebbe vue-router al render.
		 */
		modelDefOfRecord(record, route) {
			const props = record && record.props && record.props.default
			if (!props) {
				return null
			}

			if (typeof props === 'function') {
				try {
					return (props(route) || {}).modelDef || null
				} catch (e) {
					// props che si aspetta parametri che ancora non ci sono: al
					// massimo si perde la prenotazione, ci pensa la Crud
					return null
				}
			}

			return typeof props === 'object' ? props.modelDef || null : null
		},

		openWidget() {
			this.supportDialog = true
		},

		networkStatus(event) {
			if(event.type == (this.$store.getters.isOnline ? 'online' : 'offline')) return;
			navigator.onLine ? this.$store.commit('goOnline') : this.$store.commit('goOffline')
			let isOnline = this.$store.getters.isOnline
			this.$eventBusUtility.$emit(isOnline ? 'online' : 'offline')
			let snackcolor, snackmessage
			if(isOnline) {
				window.onbeforeunload = (() => {return true})
				snackcolor = 'success'
				snackmessage = 'GiveMeHive è online'
				this.$store.dispatch('uploadDB').then(() => {
					this.$store.dispatch('syncDB').then(() => {
						this.$eventBusUtility.$emit('uploadedDB')
					})
				})
			} else {
				window.onbeforeunload = (() => {return false})
				snackcolor = 'red'
				snackmessage = 'GiveMeHive è offline'
			}
			this.$store.commit('SET_NOTIFICATIONS_STATUS', isOnline)
			this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
		},



		backButton: function() {
			return false
			return this.$routerHistory.hasPrevious() && this.$route.name !== 'companies' && this.$route.name !== 'login' && this.$route.name !== 'register'
		},

		logout() {
			this.logoutDialog = false
			localStorage.removeItem('is_impersonating')
			this.$store.dispatch('AUTH_LOGOUT')
		},

		/**
		 * Gestisce l'evento di pausa dell'app (background)
		 */
		onPause() {
			// Handle the pause lifecycle event
			console.log('App in background')
		},

		/**
		 * Gestisce l'evento di resume dell'app (foreground)
		 */
		onResume() {
			// Handle the resume lifecycle event
			console.log('App in foreground')
			// Qui puoi aggiungere logica per sincronizzare dati quando l'app torna in primo piano
		},

		/**
		 * Gestisce il pulsante back su Android
		 */
		onBackKeyDown() {
			// Handle the back-button event on Android
			if (this.$router.currentRoute.name !== 'login') {
				this.$router.go(-1)
			}
		},

		/**
		 * Applica l'aggiornamento pulendo la cache e ricaricando
		 */
		applyUpdate() {
			this.$store.commit('setUpdateAvailable', false)
			// Salva la versione accettata per evitare che lo snackbar ricompaia
			// nel caso il reload non carichi il nuovo bundle
			fetch('./version.json?t=' + Date.now())
				.then(res => res.json())
				.then(data => { localStorage.minor_ack = data.minor })
				.catch(() => {})
				.finally(() => {
					// Mette ?v= PRIMA del # così il server riceve il cache-buster
					window.location.href = window.location.origin
						+ window.location.pathname
						+ '?v=' + Date.now()
						+ window.location.hash
				})
		}
	}
}
</script>

<style>
/* quantita' da convertire nelle pagine di evasione/reso: con molte colonne la
   tabella schiaccia la cella e il campo resterebbe largo pochi pixel */
.conversion-quantity {
	min-width: 110px;
}
/* v-main ha altezza automatica e non scorre mai (scorre la finestra), ma overflow hidden/auto lo
   rende comunque un contenitore di scroll e blocca position: sticky (es. i tab di navigazione)
   rispetto alla finestra; clip taglia uguale senza diventarlo. Fallback a hidden dove clip non c'e'. */
.v-main.main-clip-x {
	overflow-x: hidden;
}
@supports (overflow: clip) {
	.v-main.main-clip-x {
		overflow: clip;
	}
}
body {
	padding-top: constant(safe-area-inset-top);
	padding-top: env(safe-area-inset-top);
}
.footer{ /* Apply this to v-bottom-nav if necessary. */
	margin-bottom: constant(safe-area-inset-bottom);
	margin-bottom: env(safe-area-inset-bottom);
}
html {
	overflow-y: auto !important;
}

/* Scheda della chiamata in arrivo: non modale, l'operatore deve poter
   continuare a lavorare mentre il telefono squilla. Il selettore parte da
   .v-application perche' .v-card di Vuetify, a pari specificita' e iniettato
   dopo, rimetterebbe la scheda nel flusso in cima alla pagina. */
.v-application .incoming-call-card {
	position: fixed !important;
	top: auto;
	left: auto;
	right: 16px;
	bottom: 16px;
	max-width: calc(100vw - 32px);
	z-index: 12;
}

.v-application .incoming-call-handle {
	cursor: move;
	touch-action: none;
	user-select: none;
}

.v-application .incoming-call-list {
	max-height: 220px;
	overflow-y: auto;
}

.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
    background-color: rgba(0,0,0,0.0);
}

.item-menu > div {
	font-size: 12px !important;
}

#module .v-list-item--dense, .v-list--dense .v-list-item {
    min-height: 37px !important;
}

#module .v-list-item__action {
    margin-right: 0px !important;
}
#module .v-list-group__items {
	opacity: 0.92;
    border-radius: 12px;
    margin-left: 12px;
    margin-top: 4px;
    margin-bottom: 4px;
    padding-left: 8px;
    border-left: 2px solid var(--module-group-border, rgba(255, 193, 7, 0.35)); /* segue app_color, fallback giallo */
    background-color: rgba(0, 0, 0, 0.025);
}
.theme--dark #module .v-list-group__items {
    background-color: rgba(255, 255, 255, 0.04);
    border-left-color: var(--module-group-border-dark, rgba(255, 193, 7, 0.5));
}
#module .v-list-group__items .v-list-item-title {
    font-size: 11.5px !important;
}
#module .v-list-group__items .v-list-item__action .v-icon,
#module .v-list-group__items .v-list-item .v-icon {
    font-size: 16px !important;
}

/* Custom class for outlined cards with background-2 in dark mode */
.v-card.outlined-card {
    background-color: var(--v-background-2-base) !important;
    border: thin solid !important;
    border-color: rgba(0, 0, 0, 0.12) !important;
}

.theme--dark .v-card.outlined-card {
    border-color: rgba(255, 255, 255, 0.12) !important;
}

/* Puoi rimuovere o semplificare il resto degli stili ridondanti */
.theme--dark .v-card--outlined:not(.v-sheet--outlined) {
    border: thin solid rgba(255, 255, 255, 0.12) !important;
}

.theme--dark .v-sheet--outlined {
    border: thin solid rgba(255, 255, 255, 0.12) !important;
}

.theme--dark .v-divider {
    border-color: rgba(255, 255, 255, 0.12) !important;
}


/* Fix for outlined components in dark theme */
.theme--dark .v-card.v-card--outlined {
    border: thin solid rgba(255, 255, 255, 0.12) !important;
}

.theme--dark .v-sheet.v-card--outlined {
    border: thin solid rgba(255, 255, 255, 0.12) !important;
}

.theme--dark .v-divider {
    border-color: rgba(255, 255, 255, 0.12) !important;
}


/* Fix for background-2 elements with outlined prop */
.theme--dark .background-2.v-card--outlined,
.theme--dark .background-2 .v-card--outlined {
    border: thin solid rgba(255, 255, 255, 0.12) !important;
    background-color: #424242 !important;
}

/* Mini drawer styles */
.v-navigation-drawer--mini-variant .mini-menu-item {
	justify-content: center !important;
	padding: 0 !important;
	min-height: 40px !important;
}
.v-navigation-drawer--mini-variant .mini-menu-item .v-icon {
	margin: 0 !important;
}
.v-navigation-drawer--mini-variant .mini-menu-item .v-list-item__action {
	margin: 0 !important;
	min-width: unset !important;
}
/* Fix for temporary navigation drawers - ensure no space is left when closed */
.v-navigation-drawer--temporary:not(.v-navigation-drawer--open) {
    transform: translateX(100%) !important;
    width: 0 !important;
}

/* Fix for right temporary drawers */
.v-navigation-drawer--right.v-navigation-drawer--temporary:not(.v-navigation-drawer--open) {
    transform: translateX(100%) !important;
}

/* Ensure breadcrumb visibility */
/* .v-main .container {
    position: relative;
    z-index: 1;
} */
</style>
